import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isMinimize: false,
  opened: false,
  patientId: 0,
  appointmentId: 0,
  startTime: null,
  room: null,
  role: 0,
  providerName: null,
  patientName: null,
};

const joinRoomSlice = createSlice({
  name: "joinRoom",
  initialState,
  reducers: {
    setCallData: (state, action) => {
      state.startTime = action.payload.startTime;
      state.appointmentId = action.payload.appointmentId;
      state.patientId = action.payload.patientId;
      state.room = action.payload.room;
      state.role = action.payload.role;
      state.providerName = action.payload.providerName;
      state.patientName = action.payload.patientName;
    },
    minimize: (state) => {
      state.isMinimize = true;
    },
    maximize: (state) => {
      state.isMinimize = false;
    },
    openJoinRoom: (state) => {
      state.opened = true;
      state.isMinimize = false;
    },
    closeAndResetJoinRoom: (state) => {
      Object.assign(state, initialState);
    },
  },
});

// Actions generated for each case reducer function
export const {
  minimize,
  maximize,
  openJoinRoom,
  closeAndResetJoinRoom,
  setCallData,
} = joinRoomSlice.actions;

export default joinRoomSlice.reducer;
